import { render, staticRenderFns } from "./EducationMenuToggle.vue?vue&type=template&id=7c02e938&scoped=true"
import script from "./EducationMenuToggle.vue?vue&type=script&lang=js"
export * from "./EducationMenuToggle.vue?vue&type=script&lang=js"
import style0 from "./EducationMenuToggle.vue?vue&type=style&index=0&id=7c02e938&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c02e938",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {EducationMenuItem: require('/builds/gb-developers/geekbrains-client/components/pages/education/EducationMenu/EducationMenuItem.vue').default})
